import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';


export default function Banner({ className, campaigns, promotionsOne, promotionsTwo }) {

  return (
    <>
      <div className={`w-full ${className || ""}`}>
        <div className="container-x mx-auto">
          <div className="main-wrapper w-full">
            <div className="banner-card xl:flex xl:space-x-[30px] xl:h-[600px]  mb-[30px]">
              <div data-aos="fade-right" className="xl:w-[740px] w-full xl:h-full mb-4 xl:mb-0">
                <Swiper
                  spaceBetween={10}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  lazy={true}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper"
                >
                  {campaigns?.map((campaign, index) => (
                    <SwiperSlide key={index}>
                      {/* <a href="https://b2bhashtag.com"> */}
                      <img
                        src={campaign}
                        alt=""
                        loading="lazy"
                      />
                      {/* </a> */}
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div
                data-aos="fade-left"
                className="flex-1 flex flex-col space-y-4 xl:space-y-[30px] xl:h-full"
              >
                <div className="w-full xl:h-1/2">
                  <Swiper
                    spaceBetween={10}
                    pagination={{
                      clickable: true,
                      dynamicBullets: true,
                    }}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    lazy={true}
                    modules={[Autoplay, Pagination]}
                    className="mySwiper2"
                  >
                    {promotionsOne?.map((promotion, index) => (
                      <SwiperSlide key={index}>
                        <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                          <img
                            src={promotion?.image}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="w-full xl:h-1/2">
                  <Swiper
                    spaceBetween={10}
                    pagination={{
                      clickable: true,
                      dynamicBullets: true,
                    }}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    lazy={true}
                    modules={[Autoplay, Pagination]}
                    className="mySwiper3"
                  >
                    {promotionsTwo?.map((promotion, index) => (
                      <SwiperSlide key={index}>
                        <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                          <img
                            src={promotion?.image}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
